module.exports = __webpack_public_path__ + "static/img/5.e59ca93a.png";